// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getBecomeADistributorForm = (state: ApplicationState) => {
    return state.bunzl.components.becomeADistributor;
};

export const getIsDistributorFormLoadingSelector = (state: ApplicationState) => {
    return getBecomeADistributorForm(state).isLoading;
};
